import React from 'react';
import resets from '../_resets.module.scss';
import classes from './FaTwitter/FaTwitter.module.scss';

type VectorIconProps = {
  className: string;
  children: React.ReactNode;
}

export const VectorIcon = ({ className, children }: VectorIconProps) => {
  return (
    <div className={`${resets.clapyResets} ${classes.root}`}>
        {children}
    </div>
  );
};
export const Prev = ({ className = '' }) => {
  return (
    <VectorIcon className={className}>
      <svg preserveAspectRatio='none' width={'100%'} viewBox="0 0 33 33" fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
      d='M12.1094 24.49C5.41992 24.49 0 19.0094 0 12.245C0 5.48063 5.41992 0 12.1094 0C18.7988 0 24.2188 5.48063 24.2188 12.245C24.2188 19.0094 18.7988 24.49 12.1094 24.49ZM17.7734 10.0725H12.1094V6.57181C12.1094 6.0435 11.4746 5.77688 11.1084 6.15213L5.52734 11.8253C5.29785 12.0574 5.29785 12.4277 5.52734 12.6598L11.1084 18.3329C11.4795 18.7082 12.1094 18.4416 12.1094 17.9132V14.4175H17.7734C18.0957 14.4175 18.3594 14.1509 18.3594 13.825V10.665C18.3594 10.3391 18.0957 10.0725 17.7734 10.0725Z'
      fill='#D9D9D9'
    />
    </svg>
    </VectorIcon>
  );
};
export const Next = ({ className = ''}) => {
  return (
    <VectorIcon className={className}>
      <svg preserveAspectRatio='none' width={'100%'} viewBox="0 0 33 33" fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
      d='M12.1094 24.49C5.41992 24.49 0 19.0094 0 12.245C0 5.48063 5.41992 0 12.1094 0C18.7988 0 24.2188 5.48063 24.2188 12.245C24.2188 19.0094 18.7988 24.49 12.1094 24.49ZM17.7734 10.0725H12.1094V6.57181C12.1094 6.0435 11.4746 5.77688 11.1084 6.15213L5.52734 11.8253C5.29785 12.0574 5.29785 12.4277 5.52734 12.6598L11.1084 18.3329C11.4795 18.7082 12.1094 18.4416 12.1094 17.9132V14.4175H17.7734C18.0957 14.4175 18.3594 14.1509 18.3594 13.825V10.665C18.3594 10.3391 18.0957 10.0725 17.7734 10.0725Z'
      fill='#D9D9D9'
    /></svg>
    </VectorIcon>
  );
};
export const Star = ({ className = '' }) => {
  return (
    <VectorIcon className={className} >
      <svg preserveAspectRatio='none' width={'100%'} viewBox="0 0 33 33" fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
      d='M15.756 1.00606C15.4707 0.391245 14.868 0 14.206 0C13.544 0 12.9466 0.391245 12.656 1.00606L9.1954 8.4006L1.46693 9.58551C0.821094 9.68612 0.282899 10.1556 0.083767 10.7984C-0.115365 11.4411 0.0460933 12.151 0.508941 12.626L6.11693 18.3885L4.79297 26.532C4.68533 27.2027 4.95443 27.8846 5.48724 28.2814C6.02005 28.6783 6.72509 28.7286 7.30634 28.41L14.2114 24.5814L21.1164 28.41C21.6977 28.7286 22.4027 28.6839 22.9355 28.2814C23.4683 27.879 23.7374 27.2027 23.6298 26.532L22.3004 18.3885L27.9084 12.626C28.3713 12.151 28.5381 11.4411 28.3336 10.7984C28.1291 10.1556 27.5963 9.68612 26.9504 9.58551L19.2166 8.4006L15.756 1.00606Z'
      fill='#FBED96'
    /></svg>
    </VectorIcon>
  );
};
export const Blank = ({ className = '' }) => {
  return (
    <VectorIcon className={className}>
      <svg preserveAspectRatio='none' width={'100%'} viewBox="0 0 20 20" fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
      d='M12.6562 10.2525H11.7188C11.5944 10.2525 11.4752 10.3065 11.3873 10.4026C11.2994 10.4987 11.25 10.6291 11.25 10.7651V14.3534H1.875V4.10099H6.09375C6.21807 4.10099 6.3373 4.04698 6.42521 3.95084C6.51311 3.85471 6.5625 3.72432 6.5625 3.58836V2.56312C6.5625 2.42716 6.51311 2.29677 6.42521 2.20064C6.3373 2.1045 6.21807 2.05049 6.09375 2.05049H1.40625C1.03329 2.05049 0.675604 2.21252 0.411881 2.50092C0.148158 2.78933 0 3.18049 0 3.58836L0 14.8661C0 15.2739 0.148158 15.6651 0.411881 15.9535C0.675604 16.2419 1.03329 16.4039 1.40625 16.4039H11.7188C12.0917 16.4039 12.4494 16.2419 12.7131 15.9535C12.9768 15.6651 13.125 15.2739 13.125 14.8661V10.7651C13.125 10.6291 13.0756 10.4987 12.9877 10.4026C12.8998 10.3065 12.7806 10.2525 12.6562 10.2525ZM14.2969 0H10.5469C9.9208 0 9.60791 0.830129 10.0488 1.3136L11.0956 2.45835L3.95508 10.2643C3.88953 10.3358 3.83752 10.4206 3.80203 10.5141C3.76654 10.6076 3.74827 10.7078 3.74827 10.809C3.74827 10.9102 3.76654 11.0104 3.80203 11.1039C3.83752 11.1973 3.88953 11.2822 3.95508 11.3536L4.61924 12.0787C4.68456 12.1504 4.76218 12.2072 4.84765 12.2461C4.93311 12.2849 5.02474 12.3048 5.11729 12.3048C5.20983 12.3048 5.30146 12.2849 5.38692 12.2461C5.47239 12.2072 5.55001 12.1504 5.61533 12.0787L12.7523 4.27143L13.7988 5.41458C14.2383 5.89517 15 5.55876 15 4.86992V0.768935C15 0.565001 14.9259 0.369419 14.7941 0.225216C14.6622 0.0810125 14.4834 0 14.2969 0Z'
      fill='white'
    /></svg>
    </VectorIcon>
  );
};
export const Prof = ({ className = ''}) => {
  return (
    <VectorIcon className={className}>
      <svg preserveAspectRatio='none' width={'90%'} viewBox="0 0 33 33" fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
      d='M35.1 33.9015H3.9C2.86566 33.9015 1.87368 33.455 1.14228 32.6603C0.410892 31.8656 0 30.7877 0 29.6638V4.23768C0 3.11378 0.410892 2.03591 1.14228 1.24119C1.87368 0.446469 2.86566 0 3.9 0H35.1C36.1343 0 37.1263 0.446469 37.8577 1.24119C38.5891 2.03591 39 3.11378 39 4.23768V29.6638C39 30.7877 38.5891 31.8656 37.8577 32.6603C37.1263 33.455 36.1343 33.9015 35.1 33.9015ZM5.85 19.0696V23.3073H27.3V19.0696H5.85ZM5.85 10.5942V14.8319H33.15V10.5942H5.85Z'
      fill='#FFA9CD'
    /></svg>
    </VectorIcon>
  );
};